import { useEffect } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { WINGS, OTHER_WING } from './wings';
import './wings.css';

/**
 * Sets `data-wing` on <html> so the accent, ground, and section rhythm
 * tokens swap for everything beneath — the wings share every rule and
 * differ only by token value.
 *
 * Also renders the cross-wing band that closes every page in a wing.
 * That band is what keeps the split from reading as two websites: you
 * are never more than one click from the other half.
 */
const WingLayout = ({ wing }) => {
  const { pathname } = useLocation();
  const other = WINGS[OTHER_WING[wing]];

  useEffect(() => {
    document.documentElement.setAttribute('data-wing', wing);
    return () => document.documentElement.removeAttribute('data-wing');
  }, [wing]);

  // Sub-routes with their own hero (adventures, a post) supply their own
  // spacing; the band is the only thing shared unconditionally.
  const isIndex = pathname === WINGS[wing].path;

  return (
    <>
      <Outlet />

      <aside className={`cross ${isIndex ? 'cross--index' : ''}`}>
        <div className="container cross__inner">
          <p className="cross__label">{other.crossLabel}</p>
          <Link to={other.path} className="cross__cta">
            {other.crossCta} <span aria-hidden="true">&rarr;</span>
          </Link>
        </div>
      </aside>
    </>
  );
};

export default WingLayout;
